// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"ead33ce9","133":"6af7bdf7","237":"1347ac4a","488":"5645df3b","855":"2623eccc"}[chunkId] + ".chunk.js";
};